export default __webpack_public_path__ + "static/media/delete-white.fd952ff3.svg";